import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, find, isEmpty } from 'lodash';
import { SignupForm } from 'shared-components/flow-signup/signup-form';
import { clearNavStep, setNavStep } from '../app-main/actions/nav';
import { fetchEntitlementsDetails, fetchProfileForEntitlements } from '../app-main/actions/entitlements';
import { initAuth, updateProfile } from '../app-main/actions/auth';
import { Avatar } from 'shared-components/image/avatar';
import { SocialEmail } from 'shared-components/flow-social/social-email-form';
import { urlHashToObject } from 'lib/url_utils';
import { PageSpinner } from 'shared-components/decorators/spinner';
import SignupSocialProof from './SignUpSocialProof';
import SignUpFooter from './SignUpFooter';
import { Helpers } from 'shared-components/helpers/helpers';
import { Profile } from 'api/api-profile';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Cookie from 'react-cookie';
import { Cloudinary } from 'api/api-cloudinary';
import { SignupErrors } from 'shared-components/nextjs/auth/signup/SignupManager/signup-errors';
import { Session } from '../shared-components/api/api-user';
import jwt from 'jsonwebtoken';

class SignupMain extends Component {
  constructor (props) {
    super(props);

    // Apple signup url hash
    // Get token information and other misc. data
    const hashContent = urlHashToObject();
    const {
      tok = '',
      email = '',
      first = '',
      last = '',
      provider = ''
    } = hashContent;
    const decodedEmail = decodeURIComponent(email);

    this.state = {
      creditValue: 0,
      referrerFirstName: '',
      referrerAvatarId: '',
      socialData: {},
      prefilledData: email ? { email: decodedEmail } : {},
      socialProvider: provider || null,
      socialToken: tok || null,
      errorMessage: '',
      showSocialEmail: false,
      showEmailErrors: false
    };

    if (first || last || email) {
      this.state.socialData = {
        email: decodedEmail,
        first_name: first,
        last_name: last
      };
    }

    this.facebookCallbackFn = this.facebookCallbackFn.bind(this);
    this.changeEmailCallback = this.changeEmailCallback.bind(this);
    this.removePromoCookies = this.removePromoCookies.bind(this);
    this.signUpCallbackFn = this.signUpCallbackFn.bind(this);
    this.newGoogleUserCallback = this.newGoogleUserCallback.bind(this);
    this.updateAvatar = this.updateAvatar.bind(this);
    this.appleUserLogin = this.appleUserLogin.bind(this);
  }

  componentDidMount () {
    const { dispatch, params = {}, accessToken } = this.props;
    const referralId = params.referralId;

    const hashObject = urlHashToObject();
    // listening for hash changes coming from signup-form if an alt account has been found
    window.addEventListener('hashchange', this.handleHashChange);
    // if window loads with a hash, like in apple case, we want to handle that hash
    if (hashObject.type || hashObject.provider) {
      this.handleHashChange();
    }

    if (!accessToken) {
      dispatch(setNavStep('Signup', 0));
    }

    this.removePromoCookies();
    dispatch(fetchEntitlementsDetails(`${referralId}/guest_referral`))
      .then((entitlements) => {
        const referrerInfo = find(get(entitlements, 'actions', {}), { type: 'REFERRER_ISSUE_CREDITS' }) || {};
        const ssoId = referrerInfo.pay_to;
        return dispatch(fetchProfileForEntitlements(ssoId));
      })
      .then((profile) => {
        const { first_name: referrerFirstName, avatar_id: referrerAvatarId } = profile;
        this.setState({
          referrerFirstName,
          referrerAvatarId
        });
      });
    analyticsIntegrations.signupForm('signup form viewed', { source: 'guest referral' });
  }

  componentDidUpdate (prevProps) {
    const { dispatch } = this.props;
    if (prevProps.accessToken !== this.props.accessToken) {
      dispatch(clearNavStep('', 0));
    }
  }

  componentWillUnmount () {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  handleHashChange = () => {
    const hashObject = urlHashToObject();
    if ('apple' === hashObject.provider) {
      this.appleUserLogin(hashObject);
    }
    if (hashObject.type) {
      // pass the type into our error message function to get the correct error message
      this.setState({ errorMessage: SignupErrors(hashObject.type), googleLogin: false });
      // set the email error styling
      if ('email' === hashObject.type) {
        this.setState({ showEmailErrors: true });
      }
      location.hash = '';
    }
  }

  appleUserLogin (hash) {
    const { dispatch } = this.props;
    const idToken = jwt.decode(hash.tok);
    const accessToken = PSSessions.Cookies('PSAccess');
    this.setState({
      appleLogin: true
    }, () => {
      Session.checkGrants(idToken.email, accessToken, (res) => {
        location.hash = '';
        if (res.facebook || res.google || res.email) {
          const provider = _.findKey(res, value => true === value);
          // if it is an email error we want to show the red borders around inputs
          if (res.email) this.setState({ showEmailErrors: true });
          return this.setState({ errorMessage: SignupErrors(provider) });
        }
        // if user has no existing account, we want to show the email form
        if (!res.email && !res.facebook && !res.google && !res.apple) {
          return this.setState({ showSocialEmail: true, socialProvider: 'apple', socialToken: hash.tok });
        }
        // if user has an apple account, we want to log them in
        Session.createSocial('', 'apple', '', hash.tok, (socialRes) => {
          Helpers.setCookies(socialRes);
          const userAccessToken = window.btoa(socialRes.access_token);
          const profilePath = '/v1/profiles/me';
          Profile.read(profilePath, userAccessToken, () => {
            // updating the auth state to keep nav in sync
            dispatch(initAuth(socialRes.access_token))
              .then(() => {
                // taking away the step nav
                clearNavStep('', 0);
              });
          });
        });
      });
    });
  }

  removePromoCookies () {
    PSSessions.Cookies.expire('tm_ent');
    PSSessions.Cookies.expire('promo');
    PSSessions.Cookies.expire('promo-id');
    PSSessions.Cookies.expire('host-ref-promo');
    PSSessions.Cookies.expire('host-ref-promo-user-id');
  }

  facebookCallbackFn (socialData, prefilledData, socialToken) {
    this.setState({
      socialData,
      prefilledData,
      socialProvider: 'facebook',
      socialToken,
      showSocialEmail: true
    });
  }

  newGoogleUserCallback (socialData, prefilledData, socialToken, checkErrors) {
    const referralId = this.props.params.referralId;
    this.setState({ socialData, prefilledData, socialToken, socialProvider: 'google' }, () => {
      // Create PSuser if user has a photo, first and last names longer than 1
      const skipProfilePage = prefilledData.avatar && prefilledData.first_name.length >= 2 && prefilledData.last_name.length >= 2;

      this.createNewSocialUser((response) => checkErrors(response, () => {
        if (window) {
          Helpers.setCookies(response);
        }
        analyticsIntegrations.socialAccountLogin('google', 'google', response.SSOid);
        this.updateAvatar(() => {
          if (skipProfilePage) {
            window.location.href = `/referrals/${referralId}/verify`;
          } else {
            window.location.href = `/referrals/${referralId}/profile`;
          }
        });
      }));
    });
  }

  updateAvatar (callback) {
    if (this.state.prefilledData.avatar) {
      const profileBody = {};
      const accessToken = PSSessions.Cookies('PSAccess');
      Cloudinary.create(this.state.prefilledData.avatar, (err, cloudinaryResponse) => {
        if (!err) {
          const newProfileURL = cloudinaryResponse.length ? cloudinaryResponse[0].secure_url : cloudinaryResponse.secure_url;
          profileBody.avatar_url = newProfileURL.replace('upload/', 'upload/c_crop,g_custom/');
        }

        Profile.update('me', accessToken, profileBody, callback);
      });
    } else {
      callback();
    }
  }

  createNewSocialUser (callback) {
    const { socialProvider, socialData, socialToken } = this.state;
    let email = '';
    let providerId = '';
    let first_name = '';
    let last_name = '';

    if ('google' === socialProvider) {
      email = socialData.email;
      providerId = socialData.sub;

      if (2 <= socialData.firstName.length) {
        first_name = socialData.firstName;
      }
      if (2 <= socialData.lastName.length) {
        last_name = socialData.lastName;
      }
    }
    /* pre sign-up, regardless of other entitlements,
       we will attribute the tastemaker here
       if a user has been on their page */
    const promoId = get(this.props, 'params.referralId') || PSSessions.Cookies('tm_ent') || PSSessions.Cookies('promo-id');
    const attrUrl = PSSessions.Cookies('PSAttrUrl');
    const attrRef = PSSessions.Cookies('PSAttrReferrer');
    const forterToken = window.fcToken || PSSessions.Cookies('forterToken');
    const locale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');

    const profileBody = {
      provider: socialProvider,
      provider_id: providerId,
      social_access_token: socialToken,
      username: email,
      first_name,
      last_name,
      ga_client_id: analyticsIntegrations.getGoogleAnalyticsID(),
      attr_url: attrUrl,
      attr_referrer: attrRef,
      social_data: socialData,
      unsubscribe: true,
      ...(locale && { preferred_locale: locale }),
      ...(promoId && { entitlement_id: promoId }),
      forterTokenCookie: forterToken
    };

    Profile.createSocial(profileBody, callback);
  }

  changeEmailCallback () {
    const { dispatch, params } = this.props;
    const referralId = params.referralId;
    const accessToken = PSSessions.Cookies('PSAccess');
    const fbData = this.state.prefilledData;

    dispatch(initAuth(accessToken))
      .then(() => {
        return dispatch(updateProfile(fbData));
      })
      .then((response) => {
        const profileData = get(response, 'profile', {});
        analyticsIntegrations.signupForm('account created', { source: 'guest referral' }, profileData);
        window.location.href = `/referrals/${referralId}/profile`;
      });
  }

  signUpCallbackFn (res) {
    const provider = _.findKey(res, value => true === value);

    if (provider && 'email' !== provider) {
      return this.setState({ errorMessage: SignupErrors(provider) });
    }

    const { params } = this.props;
    const referralId = params.referralId;
    const accessToken = PSSessions.Cookies('PSAccess');
    const profilePath = '/v1/profiles/me';
    Profile.read(profilePath, accessToken, (response) => {
      analyticsIntegrations.signupForm(
        'account created',
        {
          source: 'guest referral',
          method: 'email'
        },
        response
      );
      window.location.href = `/referrals/${referralId}/profile`;
    });
  }

  render () {
    const { entitlements, entitlementsError, params, accessToken, dispatch } = this.props;
    const referralId = params.referralId;
    const { referrerFirstName, referrerAvatarId } = this.state;
    const referralDiscount = find(get(entitlements, 'actions', {}), { type: 'GUEST_REFERRAL_DISCOUNT' }) || {};
    const creditValue = referralDiscount.value;
    const minBookingValue = referralDiscount.minimum_booking_subtotal;

    if (this.state.showSocialEmail) {
      return (
        <div className="SignupMain container">
          <div className="flex margin-xl-top center">
            <SocialEmail
              socialData={this.state.socialData}
              socialProvider={this.state.socialProvider}
              prefilledData={this.state.prefilledData}
              socialAccessToken={this.state.socialToken}
              extraSignupAttrs={ { source: 'guest referral' } }
              entitlementId={referralId}
              isSignupPage
              callbackFn={this.changeEmailCallback}
            />
          </div>
        </div>
      );
    }

    if (isEmpty(entitlements) && !entitlementsError) {
      return <PageSpinner additionalStyle="gray" />;
    }

    return (
      <div className='SignupMain'>
        <div className='signup-page-container ps-container-lg-margin ps-container-fixed'>
          <div className='ps-row text-center'>
            {entitlementsError ? (
              <div className='col-xs-12'>
                <img
                  src='https://assets.peerspace.com/time.svg?v=rb'
                  alt={this.props.intl.formatMessage({
                    id: 'referrals.signup_main.time',
                    defaultMessage: 'time'
                  })}
                />
                <h2>
                  <FormattedMessage
                    id='referrals.signup_main.expired_promo'
                    defaultMessage='This promo may be expired'
                  />
                </h2>
                <p>
                  <FormattedMessage
                    id='referrals.signup_main.reload'
                    defaultMessage='Sorry! This referral link may be expired or has changed. Try reloading the page, or contact the person who gave you the link.'
                  />
                </p>
              </div>
            ) : (
              <div className='col-xs-12'>
                {referrerAvatarId && (
                  <Avatar id={referrerAvatarId} className='avatar-img' />
                )}
                {referrerFirstName && creditValue && (
                  <h2>
                    <FormattedMessage
                      id='referrals.signup_main.gave_value'
                      defaultMessage='{name} gave you {value}'
                      values={{
                        name: referrerFirstName,
                        value: this.props.intl.formatNumber(creditValue, {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 0 === creditValue % 1 ? 0 : 2,
                          maximumFractionDigits: 0 === creditValue % 1 ? 0 : 2
                        })
                      }}
                    />
                  </h2>
                )}
                <p>
                  <FormattedMessage
                    id='referrals.signup_main.claim_discount'
                    defaultMessage='Sign up to claim your {creditValue} discount. Only applicable to new Peerspace users and bookings over {bookingValue}.'
                    values={{
                      creditValue: this.props.intl.formatNumber(creditValue, {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0 === creditValue % 1 ? 0 : 2,
                        maximumFractionDigits: 0 === creditValue % 1 ? 0 : 2
                      }),
                      bookingValue: this.props.intl.formatNumber(
                        minBookingValue,
                        {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits:
                            0 === minBookingValue % 1 ? 0 : 2,
                          maximumFractionDigits:
                            0 === minBookingValue % 1 ? 0 : 2
                        }
                      )
                    }}
                  />
                </p>
              </div>
            )}
            {/* isSignupPage is reserved for non-modal signup flows */}
            <div className='col-xs-12 margin-xl-top'>
              {!accessToken ? (
                <div style={{ maxWidth: '600px', margin: '0 auto' }}> 
                  <SignupForm
                    useBootstrapGrid={false}
                    hideSignIn
                    isSignupPage
                    extraSignupAttrs={{ source: 'guest referral' }}
                    facebookCallbackFn={this.facebookCallbackFn}
                    googleCallback={this.newGoogleUserCallback}
                    entitlementId={referralId}
                    callbackFn={this.signUpCallbackFn}
                    loginCallbackFn={(res) => {
                      dispatch(initAuth(res));
                    }}
                    errorMsg={this.state.errorMessage}
                    showEmailErrors={this.state.showEmailErrors}
                  />
                </div>
              ) : (
                <div className='margin-xl-top margin-xl-bottom bad-referral'>
                  <FormattedMessage
                    id='referrals.signup_main.already_have_account'
                    defaultMessage='You are not eligible for this discount because you already have an account. Share your {link} to earn credits.'
                    values={{
                      link: (
                        <a href='/referrals'>
                          <FormattedMessage
                            id='referrals.signup_main.referral_link'
                            defaultMessage='referral link'
                          />
                        </a>
                      )
                    }}
                  />
                </div>
              )}
            </div>

            <div className='col-xs-12'>
              <hr />
            </div>
          </div>

          <SignupSocialProof />
        </div>
        <SignUpFooter />
      </div>
    );

  }
}

SignupMain.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  entitlements: PropTypes.object,
  entitlementsError: PropTypes.error,
  accessToken: PropTypes.string,
  intl: intlShape
};

const mapStateToProps = (state = {}) => {
  const userSSOID = get(state, 'profile.SSOid');
  const accessToken = get(state, 'auth.accessToken');
  const entitlements = get(state, 'entitlements.referralData');
  const entitlementsError = get(state, 'entitlements.error');

  return {
    accessToken,
    userSSOID,
    entitlements,
    entitlementsError
  };
};

export default injectIntl(connect(mapStateToProps)(SignupMain));
